import {
  type FC, useMemo,
} from 'react';
import { useGetPlaceFromActivePlace } from '~/sidebar/sidebarApps/mapTools/placesTool/hooks/useGetPlaceFromActivePlace';
import { getPlacesMarkerProps } from '~/sidebar/sidebarApps/mapTools/placesTool/placesTool.helpers';
import type { ActivePlace } from '~/store/frontendState/activeMapElements/activeMapElements.state';
import { useMapSettingsActiveMarkerIndicatorSettingsSelector } from '~/store/mapSettings/markers/mapSettingsMarkers.selectors';
import { PLACES_RADIUS_CIRCLE } from '../../places/mapPlacesManager';
import { GoogleMapsOverlayViewContainer } from '../_shared/googleMapsOverlayViewContainer';
import { ActiveMarkerIndicatorComponent } from './activeMarkerIndicator.component';

type ActiveMarkerIndicatorProps = Readonly<{
  map: google.maps.Map;
  activePlace: ActivePlace;
}>;

export const ActivePlaceIndicatorOverlay: FC<ActiveMarkerIndicatorProps> = ({
  map,
  activePlace,
}) => {
  const activeMarkerIndicatorSettings = useMapSettingsActiveMarkerIndicatorSettingsSelector();

  const {
    placeDataLoaded,
    place,
    placeSearch,
  } = useGetPlaceFromActivePlace(activePlace);

  const placesMarkerSettings = useMemo(() => {
    const markerSettings = placeSearch
      ? getPlacesMarkerProps({ placeColor: placeSearch.color }).markerSettings
      : undefined;
    if (markerSettings) {
      return {
        ...markerSettings,
        marker: {
          ...markerSettings.marker,
          size: markerSettings.marker.size + PLACES_RADIUS_CIRCLE,
        },
      };
    }
    return undefined;
  }, [placeSearch]);

  if (!placeDataLoaded || !place || !placeSearch) {
    return null;
  }

  return (
    <GoogleMapsOverlayViewContainer
      position={place.location}
      map={map}
      noMouseEvents
    >
      <ActiveMarkerIndicatorComponent
        color={activeMarkerIndicatorSettings.color}
        currentActiveIndicator={activeMarkerIndicatorSettings.type}
        markerVisualSettings={placesMarkerSettings}
        size={activeMarkerIndicatorSettings.size}
        speed={activeMarkerIndicatorSettings.speed}
      />
    </GoogleMapsOverlayViewContainer>
  );
};
